<header>
    <nav class='main-panel navbar navbar-expand-sm navbar-toggleable-sm navbar-dark bg-dark box-shadow'>
        <div class="container-fluid">
            <!-- <a class="navbar-brand" [routerLink]='["/"]'></a> -->
            <img [src]="EurofinsIconPath">
            <div *ngIf="!CoreData.IsMobile" class="mx-3" style="height: 50px; width: 2px; background: white;"></div>
            <span *ngIf="!CoreData.IsMobile" style="color: white; font-size: 32px;"> {{AppName}}</span>
            <span class="display-6 col text-center my-auto" style="color: white;"> {{ PageName }}</span>
            <button appPreventDoubleClick #toto class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (throttledClick)="toggle()" [disabled]="!isLoggedIn()">
                <span class="navbar-toggler-icon"></span>
            </button>
            <!-- MOBILE -->
            <div *ngIf="isMenuTogglerDisplayed()" class="collapse navbar-collapse" [ngClass]='{"show": isExpanded }' id="navbarSupportedContent">
                <ul *ngIf="!checkIfWeAreInTheSubMenu()" class="row g-0 justify-content-start" style="list-style: none; padding-left: 0px;">
                    <li class="nav-item col-6" [routerLinkActive]='["link-active"]'>
                        <a class="nav-link text-start row align-items-center w-100" [routerLink]='["/intervention-list"]' (click)="collapse()">
                            <mat-icon>directions_boat_filled</mat-icon>
                            <div class="col-auto ms-2">Interventions</div>
                        </a>
                    </li>
                    <li class="nav-item col-6" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link text-start row align-items-center w-100" [routerLink]='["/analyse-list"]' (click)="collapse()">
                            <mat-icon>pest_control</mat-icon>
                            <div class="col-auto ms-2">Analyses</div>
                        </a>
                    </li>
                    <li class="nav-item col-6" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link text-start row align-items-center w-100" [routerLink]='["/documents"]' (click)="collapse()">
                            <mat-icon>text_snippet</mat-icon>
                            <div class="col-auto ms-2">Documents</div>
                        </a>
                    </li>
                    <li class="nav-item col-6" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link text-start row align-items-center w-100" [routerLink]='["/exports"]' (click)="collapse()">
                            <mat-icon>assessment</mat-icon>
                            <div class="col-auto ms-2">Exports</div>
                        </a>
                    </li>
                    <li class="nav-item col-6" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link text-start row align-items-center w-100" [routerLink]='["/metrologie"]' (click)="collapse()">
                            <mat-icon fontSet="material-icons-outlined">
                                device_thermostat
                            </mat-icon>
                            <div class="col-auto ms-2">Métrologie</div>
                        </a>
                    </li>
                    <li class="nav-item col-6">
                        <a class="nav-link text-start row align-items-center w-100" (click)="showVersion()" (click)="collapse()">
                            <mat-icon>outlined_flag</mat-icon>
                            <div class="col-auto ms-2">Version</div>
                        </a>
                    </li>
                </ul>
            
                <app-sub-menu *ngIf="checkIfWeAreInTheSubMenu()" [IsCollapseSubject]="IsCollapseSubject"></app-sub-menu>
            </div>
            <!-- DESKTOP -->
            <div class="collapse navbar-collapse" [ngClass]='{"show": !isMenuTogglerDisplayed()}' style="flex-grow: 0 !important;">
                <ul *ngIf="!checkIfWeAreInTheSubMenu()" class="navbar-nav ms-auto row align-items-center g-0">
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/intervention-list"]' >
                            <div>
                                <mat-icon>directions_boat_filled</mat-icon>
                            </div>
                            <div class="">
                                Interventions
                            </div>
                        </a>
                    </li>
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/analyse-list"]'>
                            <div>
                                <mat-icon>pest_control</mat-icon>
                            </div>
                            <div class="">
                                Analyses
                            </div>
                        </a>
                    </li>
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/documents"]' >
                            <div>
                                <mat-icon class="md-36">text_snippet</mat-icon>
                            </div>
                            <div class="">
                                Documents
                            </div>
                        </a>
                    </li>
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/exports"]' >
                            <div>
                                <mat-icon>assessment</mat-icon>
                            </div>
                            <div class="">
                                Exports
                            </div>
                        </a>
                    </li>
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/metrologie"]' >
                            <div>
                                <mat-icon fontSet="material-icons-outlined">
                                    device_thermostat
                                </mat-icon>
                            </div>
                            <div class="">
                                Métrologie
                            </div>
                        </a>
                    </li>
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/logistique"]' >
                            <div>
                                <mat-icon fontSet="material-icons-outlined">
                                    inventory_2
                                </mat-icon>
                            </div>
                            <div class="">
                                Logistique
                            </div>
                        </a>
                    </li>
                    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
                        <a class="nav-link row g-0 p-0" [routerLink]='["/carte"]' >
                            <div>
                                <mat-icon fontSet="material-icons-outlined">
                                    map
                                </mat-icon>
                            </div>
                            <div class="">
                                Carte
                            </div>
                        </a>
                    </li>
                    <li class="nav-item col-auto">
                        <a class="nav-link row g-0 p-0 clickable" (click)="showVersion()">
                            <div>
                                <mat-icon>outlined_flag</mat-icon>
                            </div>
                            <div class="">
                                Version
                            </div>
                        </a>
                    </li>
                </ul>

                <app-sub-menu *ngIf="checkIfWeAreInTheSubMenu()" [IsCollapseSubject]="IsCollapseSubject"></app-sub-menu>
            </div>

        </div>
    </nav>
    <div class="container-fluid background-violet-500">
        <mat-progress-bar *ngIf="Opacity === 100" [style.opacity]="Opacity" mode="indeterminate" color="accent" role="progressbar" style="z-index: 9999;">
        </mat-progress-bar>
        <div *ngIf="Opacity !== 100" style="height: 4px;"></div>
    </div>
</header>